export const environment = {
    // apiUrl: 'https://backoffice.legitid.org/dashboard/api/',
    apiUrl: 'http://localhost:6113/api/',
    oriURL: 'http://localhost:4200',
    contentPackage: 'https://api-dev.legitid.org/content/package/',
    contentOG: 'https://api-dev.legitid.org/content/organizations/',
};
